import { forwardRef, type Ref, type SVGProps } from "react";

function SvgReferralBonus(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 120 120" {...props}>
      <path
        fill="#0D2B57"
        d="M13.975.975a.975.975 0 1 0-1.95 0c0 4.056-.895 6.754-2.595 8.455-1.7 1.7-4.399 2.595-8.455 2.595a.975.975 0 1 0 0 1.95c4.056 0 6.754.895 8.455 2.595 1.7 1.7 2.595 4.399 2.595 8.455a.975.975 0 1 0 1.95 0c0-4.056.895-6.754 2.595-8.455 1.7-1.7 4.399-2.595 8.455-2.595a.975.975 0 1 0 0-1.95c-4.056 0-6.754-.895-8.455-2.595-1.7-1.7-2.595-4.399-2.595-8.455"
      />
      <g clipPath="url(#referral-bonus_svg__a)" transform="translate(16 16)">
        <circle cx="50" cy="50" r="50" stroke="url(#referral-bonus_svg__b)" strokeWidth="20" />
        <circle cx="50" cy="50" r="50" stroke="url(#referral-bonus_svg__c)" strokeWidth="20" />
        <path
          stroke="#0C1C43"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M50 31.727V28m0 37.273V69m7.796-31.682C56.24 35.09 53.331 33.591 50 33.591h-1c-4.418 0-8 2.967-8 6.626v.285c0 2.617 1.785 5.01 4.612 6.18l8.776 3.635C57.215 51.487 59 53.881 59 56.498c0 3.817-3.736 6.911-8.343 6.911H50c-3.331 0-6.24-1.499-7.796-3.727"
        />
      </g>
      <defs>
        <linearGradient
          id="referral-bonus_svg__b"
          x1="50"
          x2="50"
          y1="0"
          y2="100"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADF3C7" />
          <stop offset="1" stopColor="#F6F3F1" />
        </linearGradient>
        <linearGradient
          id="referral-bonus_svg__c"
          x1="50"
          x2="50"
          y1="0"
          y2="100"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".195" stopColor="#ADF3C7" />
          <stop offset="1" stopColor="#E5DAD3" />
        </linearGradient>
        <clipPath id="referral-bonus_svg__a">
          <rect width="100" height="100" fill="#fff" rx="50" />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgReferralBonus);
export default ForwardRef;
